import {Platform} from 'react-native';

import {config} from '../../config';

import {HeaderDisabledEntry} from './headerDenyListEntries';

export type {HeaderDisabledEntry, MegaMenuFlag} from './headerDenyListEntries';
export {HEADER_DISABLED_ENTRIES, parseHeaderDisabled} from './headerDenyListEntries';

export const isEntryDenied = (
  entry: HeaderDisabledEntry,
  list: readonly HeaderDisabledEntry[] = config.WEB_HEADER_DISABLED,
): boolean => list.includes(entry);

/** Web only: native keeps the legacy header until DIS-1902. */
export const isSiteHeaderActive = (): boolean => Platform.OS === 'web' && !isEntryDenied('HEADER');
